import { useId } from "react";
import { inputClass, labelClass } from "../../../../constants/formStyles.ts";
import type { useBlankInventory } from "../useBlankInventory.ts";

export function BlankPicker({
  form,
}: {
  form: ReturnType<typeof useBlankInventory>;
}) {
  const id = useId();
  const { inventory, blanks, setBlanks, loading, error } = form;
  return (
    <div>
      {loading && (
        <p role="status" className="text-sm">
          Зареждане на наличните бланки…
        </p>
      )}
      {Boolean(error) && (
        <p role="alert" className="text-sm text-danger">
          Бланките не се заредиха.{" "}
          <button type="button" onClick={form.refresh} className="underline">
            Опитай отново
          </button>
        </p>
      )}
      <fieldset
        disabled={loading || Boolean(error)}
        className="grid grid-cols-2 gap-2 sm:grid-cols-4"
      >
        {(["sticker", "green-card"] as const).map((kind) => {
          const seriesKey =
            kind === "sticker" ? "stickerSeries" : "greenCardSeries";
          const numberKey =
            kind === "sticker" ? "stickerNumber" : "greenCardNumber";
          const rows = (inventory?.[kind] ?? []).filter(
            (row) => kind === "sticker" || row.series.trim()
          );
          const chosen = rows.find((row) => row.series === blanks[seriesKey]);
          const seriesId = `${id}-${seriesKey}`,
            numberId = `${id}-${numberKey}`;
          return (
            <div key={kind} className="contents">
              <div>
                <label htmlFor={seriesId} className={labelClass}>
                  Серия {kind === "sticker" ? "стикер" : "сертификат"}
                </label>
                {rows.length ? (
                  <select
                    id={seriesId}
                    className={inputClass}
                    value={blanks[seriesKey] ?? ""}
                    onChange={(event) => {
                      const next = rows.find(
                        (row) => row.series === event.target.value
                      );
                      setBlanks({
                        ...blanks,
                        [seriesKey]: event.target.value,
                        [numberKey]: next?.nextAvailable ?? "",
                      });
                    }}
                  >
                    {!rows.some((row) => row.series === "") && (
                      <option value="" disabled hidden>
                        — изберете серия —
                      </option>
                    )}
                    {rows.map((row) => (
                      <option key={row.series} value={row.series}>
                        {row.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    id={seriesId}
                    className={inputClass}
                    value={blanks[seriesKey] ?? ""}
                    placeholder={kind === "sticker" ? "Без серия" : undefined}
                    onChange={(event) =>
                      setBlanks({ ...blanks, [seriesKey]: event.target.value })
                    }
                  />
                )}
              </div>
              <div>
                <label htmlFor={numberId} className={labelClass}>
                  Номер {kind === "sticker" ? "стикер" : "сертификат"}
                </label>
                {chosen ? (
                  <select
                    id={numberId}
                    className={inputClass}
                    value={blanks[numberKey] ?? ""}
                    onChange={(event) =>
                      setBlanks({ ...blanks, [numberKey]: event.target.value })
                    }
                  >
                    <option value="" disabled hidden>
                      — изберете номер —
                    </option>
                    {chosen.available.map((number) => (
                      <option key={number} value={number}>
                        {number}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    id={numberId}
                    className={inputClass}
                    value={blanks[numberKey] ?? ""}
                    onChange={(event) =>
                      setBlanks({ ...blanks, [numberKey]: event.target.value })
                    }
                  />
                )}
              </div>
            </div>
          );
        })}
      </fieldset>
    </div>
  );
}
